export const ATENDABOT_PROMPT_STATUS_EVENT = 'atendabot:prompt-status-changed';

export type AtendabotPromptStatus = {
  draftPending?: boolean;
  promptReadyToPublish?: boolean;
};

export const notifyAtendabotPromptStatus = (status: AtendabotPromptStatus) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(ATENDABOT_PROMPT_STATUS_EVENT, {
    detail: status,
  }));
};
